import type { CmpHider } from './types';

export const didomi: CmpHider = {
  id: 'didomi',
  label: 'Didomi',
  css: `
      /* Hide the Didomi cookie consent banner/popup in the preview. Didomi
         mounts its entire UI inside #didomi-host and locks page scroll via a
         body class while open. We hide the host and override that scroll lock.
         Didomi's own "body.didomi-popup-open { overflow: hidden }" rule is
         injected at runtime AFTER this style, so matching its specificity plus
         !important loses on source order — the leading "html" gives us higher
         specificity to win. The -ios variant locks via position:fixed, so we
         reset that too. */
      #didomi-host { display: none !important; }
      html body.didomi-popup-open,
      html body.didomi-popup-open-ios {
        overflow: visible !important;
        position: static !important;
      }
  `,
};
